module.exports = __webpack_public_path__ + "img/3.67d54e4e.png";